import IconPotentionGrowActive from "../../assets/icons/sorterByCard/active/globe.svg";
import IconPotentionGrowDefault from "../../assets/icons/sorterByCard/default/globe.svg";

import IconDollarFlowerActive from "../../assets/icons/sorterByCard/active/flower.svg";
import IconDollarFlowerDefault from "../../assets/icons/sorterByCard/default/flower.svg";

import IconAttantionActive from "../../assets/icons/sorterByCard/active/warning.svg";
import IconAttantionDefault from "../../assets/icons/sorterByCard/default/warning.svg";

import IconEnergyActive from "../../assets/icons/sorterByCard/active/energy.svg";
import IconEnergyDefault from "../../assets/icons/sorterByCard/default/energy.svg";

import IconRussiaActive from "../../assets/icons/sorterByCard/active/russia.svg";
import IconRussiaDefault from "../../assets/icons/sorterByCard/default/russia.svg";

import IconGPBActive from "../../assets/icons/sorterByCard/active/gpb.svg";
import IconGPBDefault from "../../assets/icons/sorterByCard/default/gpb.svg";

import IconBatteryOff from "../../assets/icons/battery-off.svg";
import IconBatteryGreen from "../../assets/icons/battery-green.svg";

import {IDataMapFiltered} from "../../pages/Dashboard/Dashboard.type";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../config/featureFlags";

import IconLaborateActive from "../../assets/icons/sorterByCard/active/lab.svg";
import IconLaborateDefault from "../../assets/icons/sorterByCard/default/lab.svg";

const baseDataMapDirectionFilters: IDataMapFiltered[] = [
  {
    id: 1,
    img: IconPotentionGrowActive,
    imgDefault: IconPotentionGrowDefault,
    option: "potentialVolume",
    title: "Прогноз мирового рынка к 2020",
    description: "Прогноз мирового рынка к 2020",
    disabled: false,
  },
  {
    id: 2,
    img: IconDollarFlowerActive,
    imgDefault: IconDollarFlowerDefault,
    option: "investVolume",
    title: "Инвестиционная активность в мире",
    description: "Инвестиционная активность в мире",
    disabled: false,
  },
  {
    id: 3,
    img: IconAttantionActive,
    imgDefault: IconAttantionDefault,
    option: "critical",
    title: "Критические технологические кластеры",
    description: "Критические технологические кластеры",
    disabled: false,
  },
  {
    id: 4,
    img: IconBatteryGreen,
    imgDefault: IconBatteryOff,
    option: "battery_russia",
    title: "Зрелость кластера",
    description: "Зрелость кластера",
    disabled: false,
  },
  {
    id: 5,
    img: IconEnergyActive,
    imgDefault: IconEnergyDefault,
    option: "growth_potential",
    title: "Потенциал роста",
    description: "Потенциал роста",
    disabled: false,
  },
  // {
  //   id: 6,
  //   img: IconGPBActive,
  //   imgDefault: IconGPBDefault,
  //   option: "gpb",
  //   title: "Присутствие ГПБ",
  //   description: "Присутствие ГПБ",
  //   disabled: false,
  // },
  {
    id: 7,
    img: IconRussiaActive,
    imgDefault: IconRussiaDefault,
    option: "national",
    title: "Кластеры в составе нац. проектов",
    description: "Кластеры в составе нац. проектов",
    disabled: false,
  },
];
const baseDataMapClusterFilters: IDataMapFiltered[] = [
  // {
  //   id: 1,
  //   img: IconPotentionGrowActive,
  //   imgDefault: IconPotentionGrowDefault,
  //   option: "marketVolume",
  //   title: "Объем мирового рынка к 2030 г.",
  //   description: "Объем мирового рынка к 2030 г.",
  //   disabled: false,
  // },
  {
    id: 2,
    img: IconDollarFlowerActive,
    imgDefault: IconDollarFlowerDefault,
    option: "investVolume",
    title: "Совокупный объем мировых инвестиций в стартапы за 2023-2024 гг.",
    description:
      "Совокупный объем мировых инвестиций в стартапы за 2023-2024 гг.",
    disabled: false,
  },
  {
    id: 3,
    img: IconBatteryGreen,
    imgDefault: IconBatteryOff,
    option: "battery_russia",
    title: "Зрелость кластера",
    description: "Зрелость кластера",
    disabled: false,
  },
  {
    id: 4,
    img: IconLaborateActive,
    imgDefault: IconLaborateDefault,
    option: "trl_tier",
    title: "Уровень научной зрелости в России",
    description: "Уровень научной зрелости в России",
    disabled: false,
  },
  {
    id: 5,
    img: IconEnergyActive,
    imgDefault: IconEnergyDefault,
    option: "growth_potential",
    title: "Потенциал роста",
    description: "Потенциал роста",
    disabled: false,
  },
  // {
  //   id: 5,
  //   img: IconGPBActive,
  //   imgDefault: IconGPBDefault,
  //   option: "gpb",
  //   title: "Присутствие ГПБ",
  //   description: "Присутствие ГПБ",
  //   disabled: false,
  // },
];

export const dataMapDirectionFilters: IDataMapFiltered[] =
  FEATURE_CLUSTER_BATTERY_METRIC_ENABLED
    ? baseDataMapDirectionFilters
    : baseDataMapDirectionFilters.filter((i) => i.option !== "battery_russia");

// NOTE: cluster view sorts TECHNOLOGIES, so Battery stays available here.
export const dataMapClusterFilters: IDataMapFiltered[] = baseDataMapClusterFilters;
